(function($) {
    $(document).ready(function(){

        $('.footer-carousel').owlCarousel({
            items: 1,
            loop:true,
            margin:15,
            lazyLoad: true,
            center:true,
            autoplay:true,
            autoplayTimeout:5000, 
            dots: true,
            smartSpeed: 1500
        });

    });
})(jQuery); // Fully reference jQuery after this point.
